import { action } from 'satcheljs';
import type MeetingTypeExtensionResponse from '../services/schema/MeetingTypeExtensionResponse';

/**
 * Action to set meetingTypeExtensions from the store.
 */
const setMeetingTypeExtensions = action(
    'setMeetingTypeExtensions',
    (meetingTypeExtensions: Map<string, MeetingTypeExtensionResponse>) => ({
        meetingTypeExtensions,
    })
);

/**
 * Action to set meetingTypeExtension from the store.
 */
export const setMeetingTypeExtension = action(
    'setMeetingTypeExtension',
    (meetingTypeExtension: MeetingTypeExtensionResponse | null) => ({
        meetingTypeExtension,
    })
);

export default setMeetingTypeExtensions;
